import { render, staticRenderFns } from "./ExportarBackup.vue?vue&type=template&id=7faf7b7e&scoped=true"
import script from "./ExportarBackup.vue?vue&type=script&lang=js"
export * from "./ExportarBackup.vue?vue&type=script&lang=js"
import style0 from "./ExportarBackup.vue?vue&type=style&index=0&id=7faf7b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faf7b7e",
  null
  
)

export default component.exports